import {Coordinates} from '@domain/coordinates';
import {BaseType, select as d3Select, selectAll as d3SelectAll, Selection as d3Selection} from 'd3-selection';

export function getUnderlyingElement({x, y}: Coordinates, parentClass: string): d3Selection<BaseType, any, BaseType, undefined> {
  let underlyingElementSelection: d3Selection<BaseType, any, BaseType, undefined> = null;

  d3SelectAll(parentClass)
    .filter('svg')
    .nodes()
    .forEach((svgGraphicsElement: SVGGraphicsElement) => {
      const {left, right, top, bottom} = svgGraphicsElement.getBoundingClientRect();

      if (x >= left && x <= right && y >= top && y <= bottom) {
        underlyingElementSelection = d3Select(svgGraphicsElement);
      }
    });

  return underlyingElementSelection;
}
